<template>
 <div v-if="visible">
		<div class="header-item">
			<template v-if="mainslug === 'users'">
				<router-link :to="`/${mainslug}`" class="btn-back"></router-link>
			</template>
			<template v-else>
				<router-link :to="`/${mainslug}/${id}`" class="btn-back"></router-link>
			</template>
			<h1 v-if="entity">Edit <i>{{ entity.translations.en.value }}</i></h1>
		</div>

		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link :to="`/${mainslug}/edit/${id}/fields`">Fields</router-link></li>
								<li><router-link :to="`/${mainslug}/edit/${id}/options`">Options</router-link></li>
								<li><a href="#" v-on:click="openSidebar" data-marker="false">Permissions</a></li>
								<!-- <li><router-link :to="`/content/edit/${id}/forms`">Forms</router-link></li> -->
								<!-- <li><router-link :to="`/content/edit/${id}/export`">Export</router-link></li> -->
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>

		<router-view :entity="entity" :forms="forms" :callback="getEntity"></router-view>

		<Sidebar :type="'privileges'" ref="sidebar" :data="entity"></Sidebar>
	</div>
</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import Sidebar from '../../components/sidebars/Sidebar.vue'

export default {
	name: 'edit-object',

	components: {
		'Sidebar': Sidebar
	},

	data () {
		return {
			id: this.$route.params.id,
			entity: null,
			forms: null,
			mainslug: this.getMainSlug(),
			roles: this.$store.state.user.roles,
			visible: false
		}
	},

	created () {
		// only 360 admin is allowed to access this page
		// other users will be send back to the dashboard
		if (!this.roles['Admin']) {
			this.$router.push('/dashboard')
			document.querySelector('body').classList.remove('loading')
			return
		}

		this.visible = true

		this.id = this.$route.params.id
		this.getEntity()

		// update codebar
		this.$root.$emit('updateCodebar', this.id)
	},

	methods: {
		getEntity () {
			// get entity
			var url = '/cms/api/entities?id=' + this.id
			xhrModule.get(url, this.getEntitiesCompleteHandler.bind(this))
		},

		getEntitiesCompleteHandler (data) {
			this.entity = data.data

			// get forms for entity
			var url = '/cms/api/forms?entity=' + this.entity.id
			xhrModule.get(url, this.getFormsCompleteHandler.bind(this))
		},

		getFormsCompleteHandler (forms) {
			// get first form in object
			var form = forms['data'][Object.keys(forms['data'])[0]]
			if (!form) {
				this.forms = {}
			} else {
				this.forms = forms['data'][Object.keys(forms['data'])[0]]
			}
		},

		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		},

		openSidebar (e) {
			e.preventDefault()

			this.$refs.sidebar.toggle(e.currentTarget)
		}
	}
}

</script>
